export enum QuoteStatus {
  Open = 1,
  Expired = 2,
  Pending = 3,
  Completed = 4
}
